import { render, staticRenderFns } from "./EmailLogDetailsModal.vue?vue&type=template&id=17623673&scoped=true&"
import script from "./EmailLogDetailsModal.vue?vue&type=script&lang=js&"
export * from "./EmailLogDetailsModal.vue?vue&type=script&lang=js&"
import style0 from "./EmailLogDetailsModal.vue?vue&type=style&index=0&id=17623673&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17623673",
  null
  
)

export default component.exports